import React, { useState, useCallback, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { CardAvatar } from "../../card/CardAvatar";
import { UploadAvatar } from "../../fields/UploadAvatar";

export function JourneyProfileEditor({ name, setName, subtitle, setSubtitle, avatar, setAvatar }) {
  const [uploadError, setUploadError] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const handleUploading = (uploading: boolean) => {
    setIsUploading(uploading);
  };

  const handleAvatarUpload = (url: string) => {
    setAvatar(url);
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <CardAvatar src={avatar} />
        <Box>
          <TextField
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <TextField
            label="Subtitle"
            value={subtitle}
            onChange={(e) => setSubtitle(e.target.value)}
            variant="outlined"
            margin="normal"
            fullWidth
          />
        </Box>
      </Box>

      <Box mb={2}>
        <UploadAvatar
          value={avatar}
          setValue={(fieldName, newUrl) => handleAvatarUpload(newUrl)}
          setError={() => {}}
          onError={(err) => setUploadError(err)}
          onUploading={handleUploading}
        >
          <Button variant="contained" fullWidth disabled={isUploading}>
            {isUploading ? "Uploading..." : "Upload new picture"}
          </Button>
        </UploadAvatar>

        {uploadError && <Typography color="error">{uploadError}</Typography>}
      </Box>
    </Box>
  );
}
